import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const LS = "aceh_rep_filter_v1";
const Ctx = createContext({ repId: "all", setRepId: () => {}, reps: [], isAdmin: false });

export function RepFilterProvider({ children }) {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [repId, setRepIdState] = useState(() => localStorage.getItem(LS) || "all");
  const [reps, setReps] = useState([]);

  useEffect(() => {
    if (!isAdmin) { setReps([]); return; }
    api.get("/users").then(({ data }) => setReps(data.filter(u => u.active !== false))).catch(() => setReps([]));
  }, [isAdmin]);

  const setRepId = (v) => { const next = v || "all"; setRepIdState(next); localStorage.setItem(LS, next); };
  const value = { repId: isAdmin ? repId : "all", setRepId, reps, isAdmin };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useRepFilter = () => useContext(Ctx);
